export const ANALYTICS_QA_T_DETAILS_TABS = {
    VARIATIONS: "VARIATIONS",
    COMMENTS: "COMMENTS",
    TICKET_INFO: "TICKET_INFO",
    TIMELINE: "TIMELINE",
};
